import chess from '../assets/chess.png';
import solvenext from '../assets/solvenext.png';
import snap from '../assets/snap.png';

const PROJECTS = [  //screen case
    {
        id:1,
        title: 'Chess State Detection',
        description: 'Given the photo of a (2D) Chess board with coins in place and indication of whose move it is, the OpenCV C++ based app predicts the next move',
        link: 'https://github.com/Krythz43/Chess-State-Detection',
        tags: "Image Processing",
        image: chess
    },

    {
        id:2,
        title: 'SolveNext-Codeforces',
        description: 'CLI version of codeforces problemsets which not only brings you all the problems present in Codeforces to your terminal effortlessly, but only orders them in the best way you should SolveNext.',
        link: 'https://github.com/Krythz43/SolveNext-Codeforces',
        tags: "Software Development, API requests",
        image: solvenext
    },

    {
        id:3,
        title: 'Large Graph Centrality Analysis',
        description: 'Testing various properties of four different graphs using Stanford\'s Network Analysis Platform as a CS60019 assignment',
        link: 'https://github.com/Krythz43/Graph-Analysis-Using-Snap-CS60017',
        tags: "Algorithms, Graph Theory",
        image: snap
    },

    {
        id:4,
        title: 'Placeholder',
        description: 'Testing various properties of four different graphs using Stanford\'s Network Analysis Platform as a CS60019 assignment',
        link: 'https://github.com/Krythz43/Graph-Analysis-Using-Snap-CS60017',
        tags: "Algorithms, Graph Theory",
        image: snap
    },

    {
        id:5,
        title: 'Chess State Detection',
        description: 'Given the photo of a (2D) Chess board with coins in place and indication of whose move it is, the OpenCV C++ based app predicts the next move',
        link: 'https://github.com/Krythz43/Chess-State-Detection',
        tags: "Image Processing",
        image: chess
    },

    {
        id:6,
        title: 'SolveNext-Codeforces',
        description: 'CLI version of codeforces problemsets which not only brings you all the problems present in Codeforces to your terminal effortlessly, but only orders them in the best way you should SolveNext.',
        link: 'https://github.com/Krythz43/SolveNext-Codeforces',
        tags: "Software Development, API requests",
        image: solvenext
    }

]; 

export default PROJECTS;


